import { render, staticRenderFns } from "./goodsSalesList.vue?vue&type=template&id=2257f388&"
import script from "./goodsSalesList.vue?vue&type=script&lang=ts&"
export * from "./goodsSalesList.vue?vue&type=script&lang=ts&"
import style0 from "./goodsSalesList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports